export const UI_VERSION = "2.1.79";
export const TAX_YEAR = new Date().getFullYear() - 1;
